import React from "react";
import { useLocation } from "react-router-dom";
import StoryBriefModal from "../StoryBriefModal";

// Legacy entry points use the same standalone brief, never a second reading UI.
export const HighlightBriefPanel = ({ story, onClose }) => {
  const location = useLocation();
  return <StoryBriefModal storyId={story?.id} from={{ path: location.pathname + location.search, label: "Source coverage" }} onClose={onClose} />;
};
export default HighlightBriefPanel;